import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for AdminList
export const AdminList = createSlice({
  name: "AdminList",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_AdminList: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_AdminList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_AdminList: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    AdminList_is_first: (state, action) => {
      state.isFirst = false;
    },
    clearDataadminlist: (state) => {
      state.data = [];
    },
  },
});
export default AdminList.reducer;
export const {
  list_AdminList,
  success_api_call_AdminList,
  failure_api_call_AdminList,
  AdminList_is_first,
  clearDataadminlist,
} = AdminList.actions;
